var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFbFooter = function SvgFbFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.606 0H4.395A4.396 4.396 0 0 0 0 4.395v21.21A4.396 4.396 0 0 0 4.395 30h21.21A4.396 4.396 0 0 0 30 25.605V4.395A4.396 4.396 0 0 0 25.605 0m-3.182 14.941-.527 2.637h-3.381v10.664h-2.637V17.578h-3.223v-2.637h3.223V9.668a3.518 3.518 0 0 1 3.516-3.516h3.222V8.79h-4.101v6.152zm5.818 10.664a2.64 2.64 0 0 1-2.637 2.637h-5.332v-8.906h3.065l1.23-6.152h-4.295v-2.637h4.102V4.395h-4.98a5.281 5.281 0 0 0-5.274 5.273v3.516h-3.223v6.152h3.223v8.906H4.395a2.64 2.64 0 0 1-2.637-2.637V4.395a2.64 2.64 0 0 1 2.637-2.637h21.21a2.64 2.64 0 0 1 2.637 2.637z"
  })));
};
export default SvgFbFooter;